export class EmailContactDetailsController {
  contactInfo: any;
  email: string;

  constructor(private notificationSettingEnum: any) {}

  $onInit(): void {
    this.contactInfo = this.notificationSettingEnum.EMAIL;
    this.email = this.notificationSettingEnum.EMAIL.getDisplayContactInformation();
  }
}

export class EmailContactDetailsComponent implements angular.IComponentOptions {
  public templateUrl: string =
    'capability-ng-notification-settings/src/components/email_contact_details/email_contact_details.html';
  public controller: any = EmailContactDetailsController;
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-notification-settings/src/components/email_contact_details/email_contact_details_controller.ts